import React, { useRef, useState, useEffect } from 'react'
import './newProduct.css';
import firebase from '../../../../config/fbConfig';
import EditProduct from './editProduct';
import xButton from './../../../assets/xButton.png'

const db = firebase.firestore();

function NewProduct(props) {
  const [categories, setCategories] = useState([]) // Holding all categories list
  let [arrExtras, setArrExtras] = useState([]) // Showing the extras added list
  let [arrOptions, setArrOptions] = useState([]) // Showing the options added list
  const forceUpdate = React.useState()[1].bind(null, {})
  const [uploadChoice, setUploadChoice] = useState(0) // 0 Means the user didn't pick his way, 1 means by URL Link, 2 means by actually uploading

  useEffect(() => {
    // Getting all categories available and setting them in categories state
    let newArr = [];
    for (let i = 0; i < props.menu.length; i++) {
      newArr.push(props.menu[i].title);
    }
    setCategories(newArr);

    // In case this component was called from the edit product component
    if (props.editedProduct != null) {
      if (props.editedProduct.noDelivery) document.getElementById('noDelivery').checked = true;
      // Seting the category's name in the right place
      setTimeout(() => {
        selectCategory.current.value = props.editedProduct.categoryName
        selectCategory.current.disabled = true;
      }, 30);

      // Setting all the right properties in their place(name, desc, price, picURL, options, extras)
      name.current.value = props.editedProduct.productName;
      desc.current.value = props.editedProduct.desc;
      price.current.value = props.editedProduct.price;

      if (props.editedProduct.options.length !== 0) { // To avoid errors using !== 0
        maxpicks.current.value = props.editedProduct.maxpicks;
        let clonedOptions = props.editedProduct.options.slice(0); // Copying in order to avoid reference to props.menu
        setArrOptions(clonedOptions);
      }

      if (props.editedProduct.extras.length !== 0) {
        let clonedExtras = props.editedProduct.extras.slice(0); // Copying in order to avoid reference to props.menu
        setArrExtras(clonedExtras);
      }

    }

  }, [])

  const name = useRef(null)
  const price = useRef(null)
  const desc = useRef()
  const pictureURL = useRef({ tagName: null })
  const options = useRef()
  const maxpicks = useRef()
  const extra = useRef()
  const extraPrice = useRef()
  const selectCategory = useRef()

  // Used when the user wants to add his item to the database
  let addItem = (e, categoryIndex, productIndex) => {

    e.preventDefault();
    if (window.location.href.includes('/en')) {
      if (name.current.value === "") {
        alert("You must enter a name for this item.")
        return;
      }
      if (price.current.value === "") {
        alert("You must enter a price.")
        return;
      }
      if (pictureURL.current.tagName === null) {
        alert("You must upload a picture or enter URL.")
        return;
      }
      if (selectCategory.current.value == "nothing") {
        alert('You must pick a category.')
        return;
      }
    } else {
      if (name.current.value === "") {
        alert("עליך לבחור שם למוצר זה.")
        return;
      }
      if (price.current.value === "") {
        alert("עליך להוסיף מחיר למוצר.")
        return;
      }
      if (pictureURL.current.tagName === null) {
        alert("עליך להעלות תמונה של המוצר או להוסיף URL לינק של תמונה.")
        return;
      }
      if (selectCategory.current.value == "nothing") {
        alert('עליך לבחור קטגוריה.')
        return;
      }
    }

    let maxOptions = null;
    if (arrOptions.length != 0) {
      if (maxpicks.current.value == "") {
        alert("You didn't enter maximum picks for options.")
        return;
      } else {
        maxOptions = maxpicks.current.value;
      }
    }

    let deliveredProduct = {
      productName: name.current.value,
      desc: desc.current.value,
      price: price.current.value,
      picURL: pictureURL.current.tagName === "INPUT" ? pictureURL.current.value : pictureURL.current,
      options: arrOptions,
      maxpicks: maxOptions,
      extras: arrExtras,
      noDelivery: document.getElementById('noDelivery').checked
    }

    // In case this component was called from the edit product component ( EDIT PRODUCT )
    if (props.editedProduct != null) {
      props.menu[categoryIndex].products[productIndex] = deliveredProduct;
      let categoryLang = 'categories' + props.chosenLang;

      db.collection('menu').doc('categories').update({
        [categoryLang]: props.menu
      });


      alert(`Successfully applied changes!`)

      // Applying reset to previous state with the new details
      props.setEditProduct(false);
      deliveredProduct.categoryName = props.menu[categoryIndex].title; // Adding category name
      props.searches[props.chosenIndex] = deliveredProduct; // Setting in the right place
      props.setSearches(props.searches);

    } else { // CREATE A NEW PRODUCT
      categoryIndex--; // Because the option "--SELECT--" doesn't count
      props.menu[categoryIndex].products.push(deliveredProduct);

      db.collection('menu').doc('categories').set({
        categories: props.menu
      });

      // Reset
      document.getElementById('form').reset();
      arrExtras = [];
      setArrExtras(arrExtras);
      arrOptions = [];
      setArrOptions(arrOptions);
      selectCategory.current.value = "nothing";
      if (pictureURL.current.tagName != "INPUT") {
        let progressElem = document.getElementById('progressWrapper').firstChild;
        progressElem.style.backgroundColor = '#21ba45';
        progressElem.style.width = '0%';
        progressElem.parentNode.style.display = 'none';
      }

      alert(`Successfully added to ${props.menu[categoryIndex].title}!`);
    }

  }

  // Updating the options arr list and rendering
  let getOptionsArr = (e, value) => {
    if (value == null) return;
    if (e.key === ".") {
      setTimeout(() => {
        if (value === "") return;
        arrOptions.push(value.substring(0, value.length));
        options.current.value = "";
        setArrOptions(arrOptions);
        forceUpdate();
      }, 0);
    }
  }

  // Updating the extras arr list and rendering
  let addToExtrasList = (e, name, price) => {
    e.preventDefault();
    if (name === "" || price === "") return;
    arrExtras.push({ name: name, price: price })
    setArrExtras(arrExtras);
    forceUpdate();
    extra.current.value = "";
    extraPrice.current.value = "";
  }

  // Used when the user clicks on extra/option to remove it from the required specific arr
  let removeThis = (source, index) => {
    if (source === "options") {
      arrOptions.splice(index, 1);
      setArrOptions(arrOptions);
      forceUpdate();
    }
    if (source === "extras") {
      arrExtras.splice(index, 1);
      setArrExtras(arrExtras);
      forceUpdate();
    }

  }
  // Used when the user picked to upload a local file, so uploading it to Firebase Storage and generating a link
  let uploadPic = (e, category) => {
    e.preventDefault();
    let fileButton = document.getElementById('fileButtton');
    let file = fileButton.files[0];
    let progressElem = document.getElementById('progressWrapper').firstChild;

    if (window.location.href.includes('/en')) {
      if (file == null) {
        alert(`You haven't uploaded any picture yet.`);
        return;
      }

      if (category === "nothing") {
        alert('You must pick a category.')
        return;
      }
      if (file.name.split('.').length !== 2) {
        alert("You are not allowed to have . in your filename");
        return;
      }
    } else {
      if (file == null) {
        alert(`לא העלאת שום תמונה עדיין.`);
        return;
      }

      if (category === "nothing") {
        alert('עליך לבחור קטגוריה.')
        return;
      }
      if (file.name.split('.').length !== 2) {
        alert("אסור שיהיה נקודה בשם קובץ התמונה, נא למחוק אותו ולנסות לעלות שוב");
        return;
      }
    }


    let chosenCategory = category.replace(/\s/g, ''); // To remove the spaces from chosen category to actually it valid name for folder in Firebase Storage

    if (file.type.match(/image/) && file.type !== 'image/svg+xml') {
      // Reset to default state before initial search
      progressElem.parentNode.style.display = 'block';
      progressElem.style.backgroundColor = '#21ba45';
      progressElem.style.width = '0%';
      progressElem.innerHTML = "";
      document.body.style.cursor = "wait";

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        var base64data = reader.result;
        const resizePic = firebase.functions().httpsCallable('resizePic');
        let newFilename = file.name.split('.')[0] + '.jpeg';

        resizePic({ file: base64data, resize: 550 })
          .then(res => {
            let uploadTask = firebase.storage().ref(chosenCategory + '/' + newFilename).putString(res.data, 'base64', { contentType: 'image/jpeg' });

            uploadTask.on('state_changed', function (snapshot) {
              let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              progressElem.style.width = progress + '%';
              console.log('Upload is ' + progress + '% done');

              if (progress == 100) {
                let completed = document.createElement('p');
                if (window.location.href.includes('/en')) {
                  completed.innerHTML = "Success !";
                } else {
                  completed.innerHTML = "הושלם !";
                }
                progressElem.appendChild(completed);
              }

            }, function (error) {
              progressElem.style.backgroundColor = 'red';
              progressElem.style.width = '100%';
              document.body.style.cursor = "default";
            }, function () {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                console.log('File available at', downloadURL);
                pictureURL.current = downloadURL;
                document.body.style.cursor = "default";
              });
            });

          })
          .catch(err => {
            if (window.location.href.includes('/en')) {
              alert("There's an error uploading this picture")
            } else {
              alert("שגיאה בהעלאת הקובץ");
            }
            console.log("There's an error", err);
            progressElem.style.width = '100%';
            progressElem.style.backgroundColor = 'red';
            document.body.style.cursor = "default";
          });
      }
    } else {
      if (window.location.href.includes('/en')) {
        alert("The file you are trying to upload isn't a picture.");
      } else {
        alert("הקובץ שאתה מנסה לעלות הוא לא מסוג תמונה.");
      }
    }
  }

  if (window.location.href.includes('/en')) {
    return (
      <div id="newProduct">
        <form id="form">
          <div id="sectionWrapper">
            <section>
              <label>Item's name <span>*</span> </label>
              <input type="text" ref={name} />

              <label>Description</label>
              <textarea rows="1" type="text" ref={desc} />

              <label>Price <span>*</span> </label>
              <input type="number" ref={price} className="numChars" />

              {uploadChoice == 0 &&
                <React.Fragment>
                  <label>Upload a Picture <span>*</span> </label>
                  <div className="fileWrapper" style={{ border: '1px solid gray', backgroundColor: 'white' }}>
                    <button style={{ left: '0', borderBottomRightRadius: '15px', borderTopRightRadius: '15px', borderBottomLeftRadius: '0', borderTopLeftRadius: '0' }} onClick={() => setUploadChoice(1)}>URL Link</button>
                    <button onClick={() => setUploadChoice(2)}>Upload Local File</button>
                  </div>
                </React.Fragment>
              }

              {uploadChoice == 1 &&
                <React.Fragment>
                  <label>Upload a Picture (URL Link) <span>*</span> </label>
                  <input type="text" ref={pictureURL} defaultValue={props.editedProduct != null ? props.editedProduct.picURL : ""} />
                </React.Fragment>
              }

              {uploadChoice == 2 &&
                <React.Fragment>
                  <label>Upload a Picture (Local File) <span>*</span> </label>
                  <div className="fileWrapper">
                    <input type="file" id="fileButtton" className="relativeInput" />
                    <button onClick={() => uploadPic(window.event, selectCategory.current.value)} style={{ width: '85px' }}><span>UPLOAD</span></button>
                  </div>
                  <div id="progressWrapper" style={{ display: 'none' }}>
                    <div></div>
                  </div>
                </React.Fragment>
              }

            </section>

            <section>
              <label>Options <span style={{ color: 'gray', fontSize: '19px' }}>(press . to apply)</span> </label>
              <input type="text" ref={options} onKeyDown={(e) => getOptionsArr(window.event, options.current.value)} />

              <label>Maximum picks for options</label>
              <input type="number" ref={maxpicks} className="numChars" />

              <label>Add extras</label>
              <input type="text" ref={extra} />

              <label>Extras price</label>
              <div className="fileWrapper">
                <input type="number" ref={extraPrice} className="relativeInput numChars" />
                <button onClick={(e) => addToExtrasList(e, extra.current.value, extraPrice.current.value)} style={{ width: '50px' }}><span>ADD</span></button>
              </div>
            </section>
          </div>

          <div className="middleWrapper" id="firstMidWrapper">
            <fieldset className="extrasOptionsList" id="optionsList">
              <legend align="center" >Options List</legend>
              {arrOptions.length == 0 ? <div>No options added.</div> :

                <ol data-info="options" className={props.chosenLang === "HE" ? 'hebrewList' : ""}>
                  {arrOptions.map((value, index) =>
                    <li key={value} onClick={(e) => removeThis(window.event.target.parentNode.dataset.info, index)}>{value}</li>
                  )}
                </ol>
              }
            </fieldset>

            <fieldset className="extrasOptionsList" id="extrasList">
              <legend align="center" >Extras List</legend>
              {arrExtras.length == 0 ? <div>No extras added.</div> :

                <ol data-info="extras" className={props.chosenLang === "HE" ? 'hebrewList' : ""}>
                  {arrExtras.map((value, index) =>
                    <li key={value.name} onClick={(e) => removeThis(window.event.target.parentNode.dataset.info, index)}>{value.name} <span style={{ fontSize: '20px', color: 'rgb(64, 98, 220)' }}>(€{value.price})</span></li>
                  )}
                </ol>
              }
            </fieldset>



          </div>

        </form>

        <div className="middleWrapper">
          <div>
            Select a category <span>*</span>
            <select defaultValue={"nothing"} ref={selectCategory}>
              <option disabled value="nothing">-- SELECT --</option>
              {categories.map((value) =>
                <option value={value} key={value}>{value}</option>
              )}
            </select>
          </div>

          <div>
            <input type="checkbox" id="noDelivery" name="noDelivery" />
            <label htmlFor="noDelivery">Not available for delivery?</label>
          </div>

          <div>
            <div id="getCopyElem" onClick={() => document.getElementById('editProductWrapper').style.display = 'block'}>Copy from other product (extras & options)</div>
            <div id="editProductWrapper" style={{ display: 'none' }}>
              <img src={xButton} onClick={() => document.getElementById('editProductWrapper').style.display = 'none'} />
              <EditProduct fromCopy={true} menu={props.menu} chosenLang={props.chosenLang} setArrOptions={setArrOptions} maxpicks={maxpicks.current} setArrExtras={setArrExtras} />
            </div>
          </div>

        </div>

        {props.editedProduct == null ? <button onClick={(e) => addItem(window.event, selectCategory.current.selectedIndex)} id="mainButton">Add Item</button>
          : <button onClick={(e) => addItem(window.event, props.editedProduct.categoryIndex, props.editedProduct.productIndex)} id="mainButton">Apply Changes</button>}


      </div>
    )
  }

  return (
    <div id="newProduct" className="hebrew">
      <form id="form">
        <div id="sectionWrapper">
          <section>
            <label>שם המוצר <span>*</span> </label>
            <input type="text" ref={name} />

            <label>תיאור</label>
            <textarea rows="1" type="text" ref={desc} />

            <label>מחיר <span>*</span> </label>
            <input type="number" ref={price} className="numChars" />

            {uploadChoice == 0 &&
              <React.Fragment>
                <label>העלאת תמונה <span>*</span> </label>
                <div className="fileWrapper" style={{ border: '1px solid gray', backgroundColor: 'white' }}>
                  <button style={{ left: '0', borderBottomRightRadius: '15px', borderTopRightRadius: '15px', borderBottomLeftRadius: '0', borderTopLeftRadius: '0' }} onClick={() => setUploadChoice(1)}>URL לינק</button>
                  <button onClick={() => setUploadChoice(2)}>העלה קובץ מקומי</button>
                </div>
              </React.Fragment>
            }

            {uploadChoice == 1 &&
              <React.Fragment>
                <label>העלאת תמונה (URL לינק) <span>*</span> </label>
                <input type="text" ref={pictureURL} defaultValue={props.editedProduct != null ? props.editedProduct.picURL : ""} />
              </React.Fragment>
            }

            {uploadChoice == 2 &&
              <React.Fragment>
                <label>העלאת תמונה (קובץ מקומי) <span>*</span> </label>
                <div className="fileWrapper">
                  <input type="file" id="fileButtton" className="relativeInput" />
                  <button onClick={() => uploadPic(window.event, selectCategory.current.value)} style={{ width: '85px' }}><span>העלאה</span></button>
                </div>
                <div id="progressWrapper" style={{ display: 'none' }}>
                  <div></div>
                </div>
              </React.Fragment>
            }

          </section>

          <section>
            <label>אופציות לבחירה <span style={{ color: 'gray', fontSize: '19px' }}>(לחץ . כדי להוסיף לרשימה)</span> </label>
            <input type="text" ref={options} onKeyDown={(e) => getOptionsArr(window.event, options.current.value)} />

            <label>מקסימום אופציות אפשריות</label>
            <input type="number" ref={maxpicks} className="numChars" />

            <label>שם התוספת</label>
            <input type="text" ref={extra} />

            <label>מחיר התוספת</label>
            <div className="fileWrapper">
              <input type="number" ref={extraPrice} className="relativeInput numChars" />
              <button onClick={(e) => addToExtrasList(e, extra.current.value, extraPrice.current.value)} style={{ width: '50px' }}><span>הוסף</span></button>
            </div>
          </section>
        </div>

        <div className="middleWrapper" id="firstMidWrapper">
          <fieldset className="extrasOptionsList" id="optionsList">
            <legend align="center" >רשימת אופציות</legend>
            {arrOptions.length == 0 ? <div>אין אופציות לבחירה.</div> :

              <ol data-info="options" className={props.chosenLang === "HE" ? 'hebrewList' : ""}>
                {arrOptions.map((value, index) =>
                  <li key={value} onClick={(e) => removeThis(window.event.target.parentNode.dataset.info, index)}>{value}</li>
                )}
              </ol>
            }
          </fieldset>

          <fieldset className="extrasOptionsList" id="extrasList">
            <legend align="center" >רשימת תוספות</legend>
            {arrExtras.length == 0 ? <div>אין תוספות במנה זו.</div> :

              <ol data-info="extras" className={props.chosenLang === "HE" ? 'hebrewList' : ""}>
                {arrExtras.map((value, index) =>
                  <li key={value.name} onClick={(e) => removeThis(window.event.target.parentNode.dataset.info, index)}>{value.name} <span style={{ fontSize: '20px', color: 'rgb(64, 98, 220)' }}>(€{value.price})</span></li>
                )}
              </ol>
            }
          </fieldset>



        </div>

      </form>

      <div className="middleWrapper">
        <div>
          בחר קטגוריה <span>*</span>
          <select defaultValue={"nothing"} ref={selectCategory}>
            <option disabled value="nothing">-- בחר --</option>
            {categories.map((value) =>
              <option value={value} key={value}>{value}</option>
            )}
          </select>
        </div>

        <div>
          <input type="checkbox" id="noDelivery" name="noDelivery" />
          <label htmlFor="noDelivery">לא זמין למשלוח?</label>
        </div>

        <div>
          <div id="getCopyElem" onClick={() => document.getElementById('editProductWrapper').style.display = 'block'}>העתק ממוצר אחר(תוספות ואופציות לבחירה)</div>
          <div id="editProductWrapper" style={{ display: 'none' }}>
            <img src={xButton} onClick={() => document.getElementById('editProductWrapper').style.display = 'none'} />
            <EditProduct fromCopy={true} menu={props.menu} chosenLang={props.chosenLang} setArrOptions={setArrOptions} maxpicks={maxpicks.current} setArrExtras={setArrExtras} />
          </div>
        </div>

      </div>

      {props.editedProduct == null ? <button onClick={(e) => addItem(window.event, selectCategory.current.selectedIndex)} id="mainButton">הוסף מוצר</button>
        : <button onClick={(e) => addItem(window.event, props.editedProduct.categoryIndex, props.editedProduct.productIndex)} id="mainButton">החל שינויים</button>}


    </div>
  )
}

export default NewProduct
